export default __webpack_public_path__ + "minus-button.png";